module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-SPOTIFY.8c95a48a.png";